var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.666,
    height: 19.523,
    viewBox: "0 0 13.666 19.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M14.333,3A6.828,6.828,0,0,0,7.5,9.833c0,5.125,6.833,12.69,6.833,12.69s6.833-7.565,6.833-12.69A6.828,6.828,0,0,0,14.333,3Zm0,9.273a2.44,2.44,0,1,1,2.44-2.44A2.441,2.441,0,0,1,14.333,12.273Z",
    transform: "translate(-7.5 -3)",
    fill: "#de6438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.cb01d583b1b0dbb84fb3726b2e21a3cf.svg";
export { ForwardRef as ReactComponent };